import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "../pages/home/home";
import Cgu from "../pages/home/cgu";
import Privacy from "../pages/home/privacy";
import Login from "../pages/home/login";
import PasswordRecovery from "../pages/home/PasswordRecovery";
import Dashboard from "../pages/admin/dashboard";
import Tracking from "../pages/admin/tracking";
import Ticket from "../pages/admin/ticket";
import Archive from "../pages/admin/archive";
import History from "../pages/admin/history";
import Drivers from "../pages/admin/drivers";
import Etablishments from "../pages/admin/etablishments";
import Products from "../pages/admin/products";
import Settings from "../pages/admin/settings";
import PricingPaymentsDashboard from "../pages/admin/PricingPaymentsDashboard";
import Reminder from "../pages/admin/reminder";
import Profile from "../pages/admin/profile";
import CreateProduct from "../pages/admin/create-products";
import EtablishmentProfile from "../pages/admin/etablishment-profile";
import ProtectedRoute from "./ProtectedRoute";
import { useContext, useEffect } from "react";
import UserContext from "../context/User/UserContext";
import RedirectsAdmins from "./RedirectsAdmins";
import MyPromoPrivacyPolicy from "../pages/mypromo";
import PublicAppDashboard from "../pages/admin/PublicAppDashboard.js";
import PublicAppUsers from "../pages/admin/PublicAppUsers.js";
import PublicAppOrders from "../pages/admin/PublicAppOrders.js";
import PublicAppSingleOrder from "../pages/admin/PublicAppSingleOrder.js";
import PublicAppSingleUser from "../pages/admin/PublicAppSingleUser.js";
import DashboardLayout from "../components/DashboardLayout.js";
import DeleteAccount from "../pages/home/DeleteAccount.js";
import InvoicesDashboard from "../pages/admin/InvoicesDashboard.js";
import GenerateInvoices from "../pages/admin/GenerateInvoices.js";

const Navigation = () => {
  const { user, updateUser, isLogged } = useContext(UserContext);
  const userLocalStorage = JSON.parse(localStorage.getItem("userMedik"));

  useEffect(() => {
    if (userLocalStorage) {
      console.log("user - true ");
      updateUser(userLocalStorage);
    } else {
      console.log("user - false ");
    }
  }, []);

  return (
    <Router>
      <Routes>
        {/* LANDING ROUTES */}
        <Route element={<RedirectsAdmins isAllowed={isLogged} />}>
          <Route path="/" element={<Home />} />
          <Route path="home" element={<Home />} />
          <Route path="/cgu" element={<Cgu />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/delete-account" element={<DeleteAccount />} />
          <Route path="/Login" element={<Login />} />
          <Route path="/PasswordRecovery" element={<PasswordRecovery />} />
          <Route path="/mypromo" element={<MyPromoPrivacyPolicy />} />
        </Route>
        {/* ADMIN ROUTES */}
        <Route
          element={
            <ProtectedRoute isAllowed={!!userLocalStorage || isLogged} />
          }
        >
          <Route
            path="/admin/dashboard"
            element={
              <DashboardLayout title="Dashboard" description="Vue d'ensemble des statistiques">
                <Dashboard />
              </DashboardLayout>
            }
          />
          <Route
            path="/admin/dashboard-public-app"
            element={
              <DashboardLayout title="Dashboard App Publique" description="Gestion de l'application publique">
                <PublicAppDashboard />
              </DashboardLayout>
            }
          />
          <Route
            path="/admin/public-app-users"
            element={
              <DashboardLayout title="Utilisateurs App Publique" description="Liste des utilisateurs de l'app publique">
                <PublicAppUsers />
              </DashboardLayout>
            }
          />
          <Route
            path="/admin/public-app-users/:id"
            element={
              <DashboardLayout title="Détail Utilisateur" description="Profil détaillé d'un utilisateur">
                <PublicAppSingleUser />
              </DashboardLayout>
            }
          />
          <Route
            path="/admin/public-app-orders"
            element={
              <DashboardLayout title="Commandes App Publique" description="Gestion des commandes">
                <PublicAppOrders />
              </DashboardLayout>
            }
          />
          <Route
            path="/admin/public-app-orders/:id"
            element={
              <DashboardLayout title="Détail Commande" description="Détails d'une commande spécifique">
                <PublicAppSingleOrder />
              </DashboardLayout>
            }
          />
          <Route
            path="/admin/tracking"
            element={
              <DashboardLayout title="Suivi" description="Suivi des activités et événements">
                <Tracking />
              </DashboardLayout>
            }
          />
          <Route
            path="/admin/ticket"
            element={
              <DashboardLayout title="Tickets Support" description="Gestion des tickets clients">
                <Ticket />
              </DashboardLayout>
            }
          />
          <Route
            path="/admin/archive"
            element={
              <DashboardLayout title="Archives" description="Accès aux archives">
                <Archive />
              </DashboardLayout>
            }
          />
          <Route
            path="/admin/history"
            element={
              <DashboardLayout title="Historique" description="Historique des actions">
                <History />
              </DashboardLayout>
            }
          />
          <Route
            path="/admin/drivers"
            element={
              <DashboardLayout title="Chauffeurs" description="Gestion des chauffeurs">
                <Drivers />
              </DashboardLayout>
            }
          />
          <Route
            path="/admin/drivers/:uid"
            element={
              <DashboardLayout title="Profil Chauffeur" description="Détails du chauffeur sélectionné">
                <Profile />
              </DashboardLayout>
            }
          />
          <Route
            path="/admin/etablishments"
            element={
              <DashboardLayout title="Établissements" description="Liste et gestion des établissements">
                <Etablishments />
              </DashboardLayout>
            }
          />
          <Route
            path="/admin/products"
            element={
              <DashboardLayout title="Produits" description="Gestion des produits">
                <Products />
              </DashboardLayout>
            }
          />
          <Route
            path="/admin/settings"
            element={
              <DashboardLayout title="Paramètres" description="Configuration et paramètres">
                <Settings />
              </DashboardLayout>
            }
          />

          <Route
            path="/admin/payment"
            element={
              <DashboardLayout title="Comptabilité" description="Configuration de la comptabilité">
                <PricingPaymentsDashboard />
              </DashboardLayout>
            }
          />

          <Route
            path="/admin/invoices"
            element={
              <DashboardLayout title="Factures" description="Gestion des factures">
                <InvoicesDashboard />
              </DashboardLayout>
            }
          />

          <Route
            path="/admin/invoices/generate"
            element={
              <DashboardLayout title="Factures" description="Création de factures">
                <GenerateInvoices />
              </DashboardLayout>
            }
          />

          <Route
            path="/admin/reminder"
            element={
              <DashboardLayout title="Rappels" description="Gestion des rappels">
                <Reminder />
              </DashboardLayout>
            }
          />
          <Route
            path="/admin/profile"
            element={
              <DashboardLayout title="Profil Admin" description="Paramètres et informations du compte">
                <Profile />
              </DashboardLayout>
            }
          />
          <Route
            path="/admin/create-product"
            element={
              <DashboardLayout title="Créer un Produit" description="Ajout d'un nouveau produit">
                <CreateProduct />
              </DashboardLayout>
            }
          />
          <Route
            path="/admin/etablishment-profile/:uid"
            element={
              <DashboardLayout title="Profil Établissement" description="Détails et gestion de l'établissement">
                <EtablishmentProfile />
              </DashboardLayout>
            }
          />
        </Route>
      </Routes>
    </Router>
  );
};

export default Navigation;
